"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gridStyled = require("grid-styled");
var _reactIntl = require("react-intl");
var _chevronCircleRight = _interopRequireDefault(require("react-icons/lib/fa/chevron-circle-right"));
var _chevronCircleDown = _interopRequireDefault(require("react-icons/lib/fa/chevron-circle-down"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _button = _interopRequireWildcard(require("@gravity/button"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _utils = require("@gravity/utils");
var _themeProvider = require("@gravity/theme-provider");
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _themeMapper = require("@gravity/theme-mapper");
var _jsxFileName = "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductDescription.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1u2puj4ei3() {
  var path = "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductDescription.js";
  var hash = "8899c7ddbb35b52b49099bf5ec25393e37fea8ae";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductDescription.js",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 20
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "1": {
        start: {
          line: 21,
          column: 24
        },
        end: {
          line: 30,
          column: 2
        }
      },
      "2": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 45,
          column: 2
        }
      },
      "3": {
        start: {
          line: 47,
          column: 22
        },
        end: {
          line: 57,
          column: 1
        }
      },
      "4": {
        start: {
          line: 59,
          column: 20
        },
        end: {
          line: 69,
          column: 1
        }
      },
      "5": {
        start: {
          line: 71,
          column: 28
        },
        end: {
          line: 71,
          column: 49
        }
      },
      "6": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 17
        }
      },
      "7": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 79,
          column: 6
        }
      },
      "8": {
        start: {
          line: 82,
          column: 11
        },
        end: {
          line: 84,
          column: 3
        }
      },
      "9": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 68
        }
      },
      "10": {
        start: {
          line: 83,
          column: 32
        },
        end: {
          line: 83,
          column: 65
        }
      },
      "11": {
        start: {
          line: 87,
          column: 29
        },
        end: {
          line: 87,
          column: 39
        }
      },
      "12": {
        start: {
          line: 88,
          column: 35
        },
        end: {
          line: 88,
          column: 86
        }
      },
      "13": {
        start: {
          line: 89,
          column: 23
        },
        end: {
          line: 93,
          column: 5
        }
      },
      "14": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 127,
          column: 6
        }
      },
      "15": {
        start: {
          line: 131,
          column: 0
        },
        end: {
          line: 137,
          column: 2
        }
      },
      "16": {
        start: {
          line: 139,
          column: 0
        },
        end: {
          line: 141,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 3
          }
        },
        loc: {
          start: {
            line: 75,
            column: 21
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 75
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 82,
            column: 11
          },
          end: {
            line: 82,
            column: 12
          }
        },
        loc: {
          start: {
            line: 82,
            column: 17
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 82
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 83,
            column: 18
          },
          end: {
            line: 83,
            column: 19
          }
        },
        loc: {
          start: {
            line: 83,
            column: 32
          },
          end: {
            line: 83,
            column: 65
          }
        },
        line: 83
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        },
        loc: {
          start: {
            line: 86,
            column: 11
          },
          end: {
            line: 128,
            column: 3
          }
        },
        line: 86
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 98,
            column: 13
          },
          end: {
            line: 122,
            column: 13
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 99,
            column: 14
          },
          end: {
            line: 111,
            column: 21
          }
        }, {
          start: {
            line: 113,
            column: 14
          },
          end: {
            line: 121,
            column: 21
          }
        }],
        line: 98
      },
      "1": {
        loc: {
          start: {
            line: 100,
            column: 17
          },
          end: {
            line: 104,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 100,
            column: 17
          },
          end: {
            line: 100,
            column: 41
          }
        }, {
          start: {
            line: 101,
            column: 18
          },
          end: {
            line: 103,
            column: 32
          }
        }],
        line: 100
      },
      "2": {
        loc: {
          start: {
            line: 106,
            column: 17
          },
          end: {
            line: 110,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 106,
            column: 17
          },
          end: {
            line: 106,
            column: 39
          }
        }, {
          start: {
            line: 107,
            column: 18
          },
          end: {
            line: 109,
            column: 32
          }
        }],
        line: 106
      },
      "3": {
        loc: {
          start: {
            line: 114,
            column: 17
          },
          end: {
            line: 116,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 114,
            column: 17
          },
          end: {
            line: 114,
            column: 41
          }
        }, {
          start: {
            line: 115,
            column: 18
          },
          end: {
            line: 115,
            column: 42
          }
        }],
        line: 114
      },
      "4": {
        loc: {
          start: {
            line: 118,
            column: 17
          },
          end: {
            line: 120,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 118,
            column: 17
          },
          end: {
            line: 118,
            column: 39
          }
        }, {
          start: {
            line: 119,
            column: 18
          },
          end: {
            line: 119,
            column: 35
          }
        }],
        line: 118
      },
      "5": {
        loc: {
          start: {
            line: 125,
            column: 9
          },
          end: {
            line: 125,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 125,
            column: 9
          },
          end: {
            line: 125,
            column: 29
          }
        }, {
          start: {
            line: 125,
            column: 33
          },
          end: {
            line: 125,
            column: 96
          }
        }],
        line: 125
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8899c7ddbb35b52b49099bf5ec25393e37fea8ae"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1u2puj4ei3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1u2puj4ei3();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var IconWrapper = (cov_1u2puj4ei3().s[0]++, _styledComponents.default.span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  height: 100%;\n  margin-right: 6px;\n  font-size: ", ";\n"])), _stylingConstants.default.font.sizeL));
var ChildrenWrapper = (cov_1u2puj4ei3().s[1]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    font-size: ", ";\n    margin-top: -0.8rem;\n  "])), _stylingConstants.default.font.sizeS)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n    font-size: 14px;\n    font-weight: 400;\n  "]))))));
var FlexWrapper = (cov_1u2puj4ei3().s[2]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex), (0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n    button.g-Button-small {\n      padding: 0;\n      color: var(--secondaryTextColor, currentColor);\n      span.g-Icon {\n        color: var(--secondaryTextColor, currentColor);\n      }\n      &:focus {\n        box-shadow: none;\n      }\n    }\n  "]))))));
var ArrowDownIcon = (cov_1u2puj4ei3().s[3]++, (0, _styledComponents.default)(_icon.default).attrs({
  iconName: 'riArrowDownSLine',
  size: _themeMapper.evolutionTheme.hospitality.icon.size,
  iconColor: _themeMapper.evolutionTheme.hospitality.buttons.color
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  top: -1px;\n  left: 5px;\n  height: ", ";\n  width: ", ";\n  color: ", ";\n"])), _themeMapper.evolutionTheme.hospitality.icon.size, _themeMapper.evolutionTheme.hospitality.icon.size, _themeMapper.evolutionTheme.hospitality.buttons.color));
var ArrowUpIcon = (cov_1u2puj4ei3().s[4]++, (0, _styledComponents.default)(_icon.default).attrs({
  iconName: 'riArrowUpSLine',
  size: _themeMapper.evolutionTheme.hospitality.icon.size,
  iconColor: _themeMapper.evolutionTheme.hospitality.buttons.color
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  top: -1px;\n  left: 5px;\n  height: ", ";\n  width: ", ";\n  color: ", ";\n"])), _themeMapper.evolutionTheme.hospitality.icon.size, _themeMapper.evolutionTheme.hospitality.icon.size, _themeMapper.evolutionTheme.hospitality.buttons.color));
var descriptionIdSuffix = (cov_1u2puj4ei3().s[5]++, '-description-action');

// PTE TODO should extract to UI component
var ProductDescription = /*#__PURE__*/function (_PureComponent) {
  function ProductDescription(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ProductDescription);
    cov_1u2puj4ei3().f[0]++;
    cov_1u2puj4ei3().s[6]++;
    _this = _callSuper(this, ProductDescription, [props]);
    (0, _defineProperty2.default)(_this, "toggle", (cov_1u2puj4ei3().s[8]++, function () {
      cov_1u2puj4ei3().f[1]++;
      cov_1u2puj4ei3().s[9]++;
      _this.setState(function (prevState) {
        cov_1u2puj4ei3().f[2]++;
        cov_1u2puj4ei3().s[10]++;
        return {
          collapse: !prevState.collapse
        };
      });
    }));
    cov_1u2puj4ei3().s[7]++;
    _this.state = {
      collapse: true
    };
    return _this;
  }
  (0, _inherits2.default)(ProductDescription, _PureComponent);
  return (0, _createClass2.default)(ProductDescription, [{
    key: "render",
    value: function render() {
      cov_1u2puj4ei3().f[3]++;
      var _ref = (cov_1u2puj4ei3().s[11]++, this.props),
        themeQueries = _ref.themeQueries;
      var descriptionActionBtnId = (cov_1u2puj4ei3().s[12]++, "".concat(this.props.describedById).concat(descriptionIdSuffix));
      var ariaFields = (cov_1u2puj4ei3().s[13]++, {
        'aria-labelledby': "".concat(descriptionActionBtnId, " ").concat(this.props.describedById),
        'aria-expanded': !this.state.collapse,
        'aria-controls': this.props.ariaControlId
      });
      cov_1u2puj4ei3().s[14]++;
      return /*#__PURE__*/_react.default.createElement(FlexWrapper, {
        width: 1,
        column: true,
        className: "stx-productDescription",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 95,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 96,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        id: "".concat(descriptionActionBtnId),
        small: true,
        flat: true,
        onClick: this.toggle,
        variant: _button.ButtonVariant.secondary,
        ariaFields: ariaFields,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97,
          columnNumber: 11
        }
      }, !this.state.collapse ? (cov_1u2puj4ei3().b[0][0]++, /*#__PURE__*/_react.default.createElement("span", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 99,
          columnNumber: 15
        }
      }, (cov_1u2puj4ei3().b[1][0]++, themeQueries.EQUILIBRIUM) && (cov_1u2puj4ei3().b[1][1]++, /*#__PURE__*/_react.default.createElement(IconWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 101,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(_chevronCircleDown.default, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 102,
          columnNumber: 21
        }
      }))), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.Product.less",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 105,
          columnNumber: 17
        }
      }), (cov_1u2puj4ei3().b[2][0]++, themeQueries.EVOLUTION) && (cov_1u2puj4ei3().b[2][1]++, /*#__PURE__*/_react.default.createElement(IconWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 107,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(ArrowUpIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 108,
          columnNumber: 21
        }
      }))))) : (cov_1u2puj4ei3().b[0][1]++, /*#__PURE__*/_react.default.createElement("span", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113,
          columnNumber: 15
        }
      }, (cov_1u2puj4ei3().b[3][0]++, themeQueries.EQUILIBRIUM) && (cov_1u2puj4ei3().b[3][1]++, /*#__PURE__*/_react.default.createElement(_chevronCircleRight.default, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115,
          columnNumber: 19
        }
      })), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.Product.more",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 117,
          columnNumber: 17
        }
      }), (cov_1u2puj4ei3().b[4][0]++, themeQueries.EVOLUTION) && (cov_1u2puj4ei3().b[4][1]++, /*#__PURE__*/_react.default.createElement(ArrowDownIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 119,
          columnNumber: 19
        }
      })))))), (cov_1u2puj4ei3().b[5][0]++, !this.state.collapse) && (cov_1u2puj4ei3().b[5][1]++, /*#__PURE__*/_react.default.createElement(ChildrenWrapper, {
        ml: 1,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125,
          columnNumber: 34
        }
      }, this.props.children)));
    }
  }]);
}(_react.PureComponent);
cov_1u2puj4ei3().s[15]++;
ProductDescription.propTypes = {
  children: _propTypes.default.node.isRequired,
  describedById: _propTypes.default.isRequired,
  ariaControlId: _propTypes.default.isRequired,
  /** Theme context */
  themeQueries: _utils.WithThemeQueriesType
};
cov_1u2puj4ei3().s[16]++;
ProductDescription.defaultProps = {
  themeQueries: {}
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(ProductDescription));